import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="glossary-lookup"
export default class extends Controller {
  static targets = ["input", "results", "form"]
  static values = {
    url: String,
    debounce: { type: Number, default: 300 }
  }

  connect() {
    this.timeout = null
    // Cache original content for reset
    this.originalContent = this.resultsTarget.innerHTML
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  search() {
    // Clear previous timeout
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    // Debounce the search
    this.timeout = setTimeout(() => {
      this.performSearch()
    }, this.debounceValue)
  }

  performSearch() {
    const query = this.inputTarget.value.trim()

    // If query is empty, reset to original content
    if (query.length === 0) {
      this.reset()
      return
    }

    // Build the URL with query parameter
    const url = `${this.urlValue}?value=${encodeURIComponent(query)}`

    // Use Turbo Stream to fetch and update
    fetch(url, {
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.text())
    .then(html => {
      Turbo.renderStreamMessage(html)
    })
    .catch(error => {
      console.error('Glossary lookup error:', error)
    })
  }

  reset() {
    // Restore original cached content
    this.resultsTarget.innerHTML = this.originalContent
  }

  clear(event) {
    event.preventDefault()
    this.inputTarget.value = ''
    this.reset()
  }
}
